export default __webpack_public_path__ + "static/growMoney-081bf6653f5d3e8307934e2925802dd3.jpeg";